const { inherits } = require('util');

/**
 * Error object for when decrypting a TDF package fails.
 *
 * @param message
 * @param err
 * @constructor
 */
function CorruptTdfPackage(message, err) {
  this.message = message;
  this.innerErrorMessage = err.message;
  this.err = err;
  this.name = 'CorruptTdfPackage';
}
inherits(CorruptTdfPackage, Error);

/**
 * Error object for when encrypting fails.
 *
 * @param message
 * @constructor
 */
function EncryptionError(message, innerErrorMessage) {
  this.message = message;
  this.innerErrorMessage = innerErrorMessage;
  this.name = 'EncryptionError';
}
inherits(EncryptionError, Error);

/**
 * Error object for when the message integrity has been compromised. This could be
 * a result of an invalid auth tag or the message body being altered.
 *
 * @param message
 * @param innerErrorMessage
 * @constructor
 */
function IntegrityCompromisedError(message, innerError) {
  this.message = message;
  this.innerError = innerError;
  this.name = 'IntegrityCompromisedError';
}
inherits(EncryptionError, Error);

IntegrityCompromisedError.create = function (innerError) {
  return new IntegrityCompromisedError(
    'The integrity of the payload cannot be verified.',
    innerError
  );
};

/**
 * Error object for when the private key needed for asymmetric crypto
 * is not valid.
 *
 * @param message
 * @param innerErrorMessage
 * @constructor
 */
function PrivateKeyInvalidError(message, innerError) {
  this.message = message;
  this.innerError = innerError;
  this.name = 'PrivateKeyInvalidError';
}
inherits(PrivateKeyInvalidError, Error);

PrivateKeyInvalidError.create = function (innerError) {
  return new PrivateKeyInvalidError(
    'The private key needed for decryption is invalid.',
    innerError
  );
};

module.exports = {
  EncryptionError,
  CorruptTdfPackage,
  PrivateKeyInvalidError,
  IntegrityCompromisedError,
};
